import { useSortable } from '@dnd-kit/sortable';
import type { OdinKey } from '@myosh/odin-components';
import React from 'react';
import type { FormBuilderField } from '../../../redux/slices/form-builder-slice';

interface FormBuilderFieldPreviewProps {
  field: FormBuilderField;
  groupId: OdinKey;
  children: React.JSX.Element;
}

const FormBuilderFieldPreview = ({ field, groupId, children }: FormBuilderFieldPreviewProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: (field.id ?? field.uuid)!,
    disabled: groupId === undefined,
    data: {
      type: 'field',
      field,
      groupId,
    },
  });
  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition: isDragging ? transition : undefined,
    opacity: isDragging ? 0.3 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </div>
  );
};

export default FormBuilderFieldPreview;
